/* Generic slideshow used by the editorial hero and the slideshow section.
   Without it, the first slide is shown and every link still works. */
(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_slideshow']) return;
  window.__hwsLoaded['component_slideshow'] = true;

  var config = window.hwsSettings || {};
  var strings = window.hwsStrings || {};

  class HwsSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      if (this.slides.length < 2) return;
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-slide-to]'));
      this.live = this.querySelector('[data-slides-live]');
      this.index = 0;
      this.reduced =
        window.matchMedia('(prefers-reduced-motion: reduce)').matches || config.animation === 'none';
      var self = this;

      this.dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          self.goTo(parseInt(dot.getAttribute('data-slide-to'), 10) || 0);
          self.pause();
        });
      });
      var prev = this.querySelector('[data-slides-prev]');
      var next = this.querySelector('[data-slides-next]');
      if (prev) prev.addEventListener('click', function () { self.step(-1); self.pause(); });
      if (next) next.addEventListener('click', function () { self.step(1); self.pause(); });

      this.pauseButton = this.querySelector('[data-slides-pause]');
      if (this.pauseButton) {
        this.pauseButton.addEventListener('click', function () {
          if (self.timer) { self.pause(); } else { self.play(); }
        });
      }

      this.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { self.step(1); self.pause(); }
        if (event.key === 'ArrowLeft') { self.step(-1); self.pause(); }
      });
      this.addEventListener('mouseenter', function () { self.hovering = true; });
      this.addEventListener('mouseleave', function () { self.hovering = false; });

      /* Slepen met de vinger. Niet "een halve veeg en hij springt om", maar de
         dia volgt je vinger: tijdens het slepen staan de huidige en de dia in de
         sleeprichting naast elkaar en schuiven ze precies mee. Laat je halverwege
         los, dan glijdt hij terug; ben je over de helft (of maak je een snelle
         zwiep), dan glijdt de volgende op zijn plek. */
      this.dragInit();

      if (this.dataset.autoplay === 'true' && !this.reduced) this.play();
    }

    disconnectedCallback() { this.pause(); }

    play() {
      var self = this;
      var speed = parseInt(this.dataset.speed, 10) || 6000;
      this.timer = window.setInterval(function () {
        if (!self.hovering && !document.hidden) self.step(1);
      }, speed);
      this.syncPauseButton(true);
    }

    pause() {
      window.clearInterval(this.timer);
      this.timer = null;
      this.syncPauseButton(false);
    }

    syncPauseButton(playing) {
      if (!this.pauseButton) return;
      this.pauseButton.setAttribute('aria-pressed', playing ? 'false' : 'true');
      var pauseIcon = this.pauseButton.querySelector('[data-pause-icon]');
      var playIcon = this.pauseButton.querySelector('[data-play-icon]');
      if (pauseIcon) pauseIcon.hidden = !playing;
      if (playIcon) playIcon.hidden = playing;
      this.pauseButton.setAttribute(
        'aria-label',
        playing ? strings.pauseSlideshow || 'Pause' : strings.playSlideshow || 'Play'
      );
    }

    step(direction) {
      var next = this.index + direction;
      if (next < 0) next = this.slides.length - 1;
      if (next >= this.slides.length) next = 0;
      this.goTo(next);
    }

    dragInit() {
      var self = this;
      this.viewport = this.querySelector('[data-slides]') || this;
      var raakt = null;   /* het aanraakpunt dat we volgen */
      var startX = 0;
      var startY = 0;
      var breedte = 0;
      var richting = 0;   /* -1 = naar links slepen (volgende), 1 = vorige */
      var buur = null;
      var bezig = false;
      var beslist = false;
      var laatsteX = 0;
      var laatsteTijd = 0;
      var snelheid = 0;

      var zet = function (dx) {
        self.slides[self.index].style.transform = 'translateX(' + dx + 'px)';
        if (buur) buur.style.transform = 'translateX(' + (dx - richting * breedte) + 'px)';
      };

      var opruimen = function () {
        self.viewport.classList.remove('is-dragging', 'is-settling');
        self.slides.forEach(function (slide) {
          slide.style.transform = '';
          slide.classList.remove('is-drag-partner');
        });
        buur = null;
        bezig = false;
        beslist = false;
        raakt = null;
      };

      /* Na het loslaten glijdt er nog even iets; als dat klaar is zetten we de
         nieuwe dia echt actief. Met een tijdslot erbij, want een transitionend
         kan uitblijven als er niets te animeren valt. */
      var afmaken = function (naarBuur) {
        var doelIndex = naarBuur ? self.slides.indexOf(buur) : self.index;
        self.viewport.classList.add('is-settling');
        self.viewport.classList.remove('is-dragging');
        zet(naarBuur ? richting * breedte : 0);
        var klaar = function () {
          if (naarBuur && doelIndex >= 0) {
            /* eerst de klassen omzetten, dan de inline verschuiving weghalen:
               anders zie je de dia even terugspringen */
            self.slides.forEach(function (slide, n) {
              var actief = n === doelIndex;
              slide.classList.toggle('is-active', actief);
              if (actief) { slide.removeAttribute('aria-hidden'); } else { slide.setAttribute('aria-hidden', 'true'); }
            });
            self.index = doelIndex;
            self.syncDots(doelIndex);
          }
          opruimen();
        };
        var eenmalig = function () {
          self.slides[self.index].removeEventListener('transitionend', eenmalig);
          klaar();
        };
        self.slides[self.index].addEventListener('transitionend', eenmalig);
        window.setTimeout(function () {
          if (bezig) { self.slides[self.index].removeEventListener('transitionend', eenmalig); klaar(); }
        }, 420);
      };

      this.viewport.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1 || bezig) return;
        raakt = event.touches[0].identifier;
        startX = laatsteX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        laatsteTijd = event.timeStamp;
        snelheid = 0;
        beslist = false;
        breedte = self.viewport.getBoundingClientRect().width || 1;
      }, { passive: true });

      /* Niet passief: zodra we weten dat het zijwaarts is, moeten we het
         meescrollen van de pagina kunnen tegenhouden. */
      this.viewport.addEventListener('touchmove', function (event) {
        if (raakt === null) return;
        var vinger = null;
        for (var n = 0; n < event.touches.length; n++) {
          if (event.touches[n].identifier === raakt) vinger = event.touches[n];
        }
        if (!vinger) return;
        var dx = vinger.clientX - startX;
        var dy = vinger.clientY - startY;

        if (!beslist) {
          /* Eerst uitmaken of dit een zijwaartse beweging is. Verticaal scrollen
             van de pagina mag niet gekaapt worden. */
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dx) <= Math.abs(dy)) { raakt = null; return; }
          beslist = true;
          bezig = true;
          self.pause();
          self.viewport.classList.add('is-dragging');
        }

        var nieuweRichting = dx < 0 ? -1 : 1;
        if (nieuweRichting !== richting || !buur) {
          if (buur) buur.classList.remove('is-drag-partner');
          richting = nieuweRichting;
          var buurIndex = self.index - richting;
          if (buurIndex < 0) buurIndex = self.slides.length - 1;
          if (buurIndex >= self.slides.length) buurIndex = 0;
          buur = self.slides[buurIndex];
          buur.classList.add('is-drag-partner');
        }

        event.preventDefault();
        zet(dx);

        var nu = event.timeStamp;
        if (nu > laatsteTijd) {
          snelheid = (vinger.clientX - laatsteX) / (nu - laatsteTijd);
          laatsteX = vinger.clientX;
          laatsteTijd = nu;
        }
      }, { passive: false });

      var einde = function (event) {
        if (raakt === null) return;
        if (!bezig) { raakt = null; return; }
        var vinger = null;
        for (var n = 0; n < event.changedTouches.length; n++) {
          if (event.changedTouches[n].identifier === raakt) vinger = event.changedTouches[n];
        }
        var dx = vinger ? vinger.clientX - startX : 0;
        /* Over de helft, of een snelle zwiep van meer dan 0,5px per ms: doorgaan.
           Anders glijdt hij terug naar waar hij stond. */
        var doorgaan = Math.abs(dx) > breedte * 0.5 || Math.abs(snelheid) > 0.5;
        afmaken(doorgaan && Math.sign(dx) === richting);
      };
      this.viewport.addEventListener('touchend', einde, { passive: true });
      this.viewport.addEventListener('touchcancel', einde, { passive: true });
    }

    syncDots(index) {
      this.dots.forEach(function (dot, i) {
        var actief = i === index;
        dot.classList.toggle('is-active', actief);
        dot.setAttribute('aria-selected', actief ? 'true' : 'false');
      });
      if (this.live) {
        this.live.textContent = (strings.slide || '{{ index }} / {{ total }}')
          .replace('{{ index }}', index + 1)
          .replace('{{ total }}', this.slides.length);
      }
    }

    goTo(index) {
      if (index === this.index || !this.slides[index]) return;
      var self = this;
      this.slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) { slide.removeAttribute('aria-hidden'); } else { slide.setAttribute('aria-hidden', 'true'); }
      });
      this.dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.index = index;
      if (this.live) {
        this.live.textContent = (strings.slide || '{{ index }} / {{ total }}')
          .replace('{{ index }}', index + 1)
          .replace('{{ total }}', this.slides.length);
      }
    }
  }
  if (!customElements.get('hws-slideshow')) customElements.define('hws-slideshow', HwsSlideshow);
})();
